import AxiosInterceptor from '../services/axiosInterceptor.service';
import { EMPTY_ERROR, FETCH_OTP_REQUEST, GET_OTP, OTP_FAILURE, SUBMIT_OTP } from './types';

export const getOtp = payload => dispatch => {
  dispatch({
    type: FETCH_OTP_REQUEST
  });
  return AxiosInterceptor.post(`${process.env.REACT_APP_API_URL}/otp/nextgen/getOtp`, payload).then(res => {
    dispatch({
      type: GET_OTP,
      payload: res.data
    });
    return res.data;
  }).catch(err => {
    dispatch({
      type: OTP_FAILURE,
      payload: err.response.data
    });
    throw err.response.data;
  });
}

export const submitOtp = payload => dispatch => {
  dispatch({
    type: FETCH_OTP_REQUEST
  });
  return AxiosInterceptor.post(`${process.env.REACT_APP_API_URL}/otp/nextgen/verifyOtp`, payload).then(res => {
    dispatch({
      type: SUBMIT_OTP,
      payload: res.data
    });
    return res.data;
  }).catch(err => {
    dispatch({
      type: OTP_FAILURE,
      payload: err.response.data
    });
    throw err.response.data;
  });
}

export const emptyOtpError = () => dispatch => {
  dispatch({
    type: EMPTY_ERROR
  });
};
